import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'primeng';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { EgdCouponsComponent } from './egd-coupons/egd-coupons.component';
import { AppVersionsComponent } from './app-versions/app-versions.component';

@NgModule({
    declarations: [EgdCouponsComponent, AppVersionsComponent],
    imports: [CommonModule, PrimengModule, SharedModule]
})
export class AdminModule {}
